@if (!item.hidden) {
  <!-- item.url -->
  @if (item.url && !item.externalUrl) {
    <a
      class="dropdown-item d-flex align-items-center"
      [ngClass]="item.classes"
      [routerLink]="[item.url]"
      [target]="item.openInNewTab ? '_blank' : '_self'">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.externalUrl -->
  @if (item.url && item.externalUrl) {
    <a
      class="dropdown-item d-flex align-items-center"
      [ngClass]="item.classes"
      [href]="item.url"
      [target]="item.openInNewTab ? '_blank' : '_self'">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <ng-template #itemContent>
    @if (item.icon) {
      <span [data-feather]="item.icon"></span>
    }
    <span [translate]="item.translate">{{ item.title }}</span>
  </ng-template>
}
